module.exports = __webpack_public_path__ + "img/back.0aa2bdb1.svg";